import { useContext } from 'react';
import { RouteHistoryContext } from '../providers/RouteHistoryProvider';

export function useRouteHistory() {
  const context = useContext(RouteHistoryContext);
  if (!context)
    throw new Error(
      'useRouteHistory should be used within RouteHistoryProvider',
    );

  return context;
}
